import { Icon } from '@hivewatch/dark'

import { Hivewatch } from '@/components/icons'

export const HivewatchIcon = () => {
  return <Icon as={Hivewatch} boxSize='16px' />
}
